import Swiper from 'swiper'
import { A11y, Autoplay, Pagination } from 'swiper/modules'

import { select } from '@js/util/select.js'
import { trackVisibility } from '@js/util/visibility.js'

select('.wpce-image-slider', sliderElement => {
  if (!(sliderElement instanceof HTMLElement)) return

  const autoplayDuration = Number(sliderElement.dataset.autoplayDuration) || 0
  const autoplayEnabled = autoplayDuration > 0

  const swiper = new Swiper(sliderElement.querySelector('.swiper'), {
    modules: [A11y, Autoplay, Pagination],

    // Optional parameters
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 30,
    speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 300,

    // Don't set threshold to 0 as this can cause scrolling issues in iOS
    threshold: 15,
    loop: true,

    a11y: {
      enabled: true,
    },

    autoplay: autoplayEnabled
      ? {
          disableOnInteraction: true,
          delay: autoplayDuration * 1000,
        }
      : false,

    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  })

  // Start/stop autoplay based on slider visibility
  if (autoplayEnabled) {
    trackVisibility(sliderElement, isVisible => {
      if (isVisible) {
        swiper.autoplay.start()
      } else {
        swiper.autoplay.stop()
      }
    })
  }

  function stopAutoplay() {
    swiper.autoplay.stop()
  }

  // Stop autoplay when pagination bullets are clicked
  if (autoplayEnabled) {
    sliderElement.querySelector('.swiper-pagination').addEventListener('click', stopAutoplay)
  }

  return () => {
    sliderElement.querySelector('.swiper-pagination').removeEventListener('click', stopAutoplay)
    swiper.destroy()
  }
})
